@import "@workbench/core/dist/scss/utility";
@import "plyr/src/sass/plyr";

:host {
  iframe,
  .plyr--video {
    display: block;
    height: 100%;
    width: 100%;
  }

  .plyr__poster {
    background-size: cover;
    background-position: center;
  }

  .privacy-shield {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    color: var(--wb-grey-15, #262626);
    padding: var(--wb-spacing-s, 1.5rem);
    z-index: 1;

    &__container {
      background-color: var(--wb-white, #fff);
      border-radius: 4px;
      box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%), 0 16px 24px 0 rgb(0 0 0 / 10%);
      overflow-y: auto;
      width: 80%;
      max-width: 800px;
      max-height: 95%;
    }

    &__iframe-container {
      position: relative;
      overflow: hidden;
      width: 100%;
      padding-top: 56.25%;
    }

    &__player-container {
      position: relative;
      width: 100%;
    }

    &__iframe {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }

    &__main {
      padding: var(--wb-spacing-xs, 1rem);
    }

    &__heading {
      margin-bottom: var(--wb-spacing-xxs, 0.5rem);
      margin-top: 0;
      hyphens: auto;
    }

    &__description {
      color: var(--wb-grey-45, #767676);
      hyphens: auto;
    }

    &__button-container {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      padding: var(--wb-spacing-s, 1.5rem) var(--wb-spacing-xs, 1rem);
      border-top: 1px solid var(--wb-grey-85, #e8e8e8);

      > .privacy-shield__button {
        text-align: center;

        &:not(:last-child) {
          margin-right: 20px;
        }
      }
    }

    @media screen and (max-width: 768px) {
      &__button-container {
        flex-wrap: wrap;

        > .privacy-shield__button {
          width: 100%;

          &:not(:last-child) {
            margin-right: 0;
            margin-bottom: var(--wb-spacing-xs, 1rem);
          }
        }
      }
    }

    &--small {
      &__button-container {
        flex-wrap: wrap;

        > .privacy-shield__button {
          width: 100%;

          &:not(:last-child) {
            margin-right: 0;
            margin-bottom: var(--wb-spacing-xs, 1rem);
          }
        }
      }
    }
  }
}
